import { createStore, applyMiddleware } from "redux";
import { logger } from "redux-logger";
import thunk from "redux-thunk";

import rootReducer from "./root.reducer";

import { persistStore } from "redux-persist";

const middleWares = [thunk];

if (process.env.NODE_ENV === "development") middleWares.push(logger);

export const store = createStore(
  rootReducer, 
  //   compose(
  //     window.__REDUX_DEVTOOLS_EXTENSION__ &&
  //       window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(...middleWares)
  //   )
);
export const persistor = persistStore(store);

// JSON.parse(JSON.parse(localStorage.getItem('persist:root')).reqs)
